<scu-title-header>{{ 'thanks.description'  | translate }}</scu-title-header>

  <div class="align-self-center text-center">
    <img src="/assets/img/illustration/Caller_heart_Woman_call_RGB.svg" height="250" width="266" alt="" class="pb-3">
    <label class="mb-4"> {{ 'thanks.p1' | translate }} </label>
  </div>
